import {QueryObserverOptions, WithRequired} from '@tanstack/react-query';
import {duration} from 'moment';

type ApiQueryOption = WithRequired<QueryObserverOptions, 'queryKey'>;

export const apiQueryOptions = {
  anomalousStageList: (blueprintId: string | undefined, queryParams: string): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'anomalous stage list', queryParams],
    gcTime: +duration(30, 'seconds'),
    refetchInterval: +duration(30, 'seconds'),
  }),
  anomalyList: (blueprintId: string | undefined): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'anomaly list'],
    gcTime: +duration(30, 'seconds'),
    refetchInterval: +duration(30, 'seconds'),
  }),
  blueprintPredefinedDashboards: (blueprintId: string | undefined): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'predefined dashboards'],
    gcTime: Infinity,
    staleTime: Infinity,
  }),
  blueprintProbes: (blueprintId: string | undefined): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'probes'],
    refetchInterval: +duration(10, 'seconds'),
  }),
  blueprintReferenceDesign: (blueprintDesign: string): ApiQueryOption => ({
    queryKey: ['blueprint reference design', blueprintDesign],
    gcTime: Infinity,
    staleTime: Infinity,
  }),
  dashboardDetails: (blueprintId: string | undefined, dashboardId: string | undefined): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'dashboard', dashboardId, 'details'],
    refetchInterval: +duration(10, 'seconds'),
  }),
  diskSpaceUsageForProbe: (blueprintId: string | undefined, probeId: string | undefined): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'probe', probeId, 'disk space usage'],
  }),
  diskSpaceUsageForStage: (
    blueprintId: string | undefined, probeId: string | undefined, stageName: string | undefined
  ): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'probe', probeId, 'stage', stageName, 'disk usage']
  }),
  predefinedDashboardList: (blueprintId: string) => ({
    queryKey: ['blueprints', blueprintId, 'predefined dashboards'],
    refetchInterval: +duration(10, 'seconds'),
  }),
  predefinedProbes: (blueprintId: string): ApiQueryOption => ({
    queryKey: ['blueprints', blueprintId, 'predefined probes'],
  }),
  probeDetails: (blueprintId: string | undefined, probeId: string | undefined): ApiQueryOption => ({
    gcTime: +duration(10, 'seconds'),
    queryKey: ['blueprints', blueprintId, 'probe', probeId, 'details'],
    refetchInterval: +duration(10, 'seconds'),
  }),
  probeStage: (blueprintId: string, probeId: string, queryParams: any, body: any): ApiQueryOption => ({
    gcTime: +duration(10, 'seconds'),
    queryKey: ['blueprints', blueprintId, 'probe', probeId, 'stage', 'items', {queryParams, body}],
    refetchInterval: +duration(10, 'seconds'),
  }),
  telemetryServiceRegistry: (): ApiQueryOption => ({
    queryKey: ['telemetry service registry']
  }),
  telemetryServiceWarnings: (
    blueprintId: string, probeId: string, stageName: string, queryParams: any
  ): ApiQueryOption => ({
    gcTime: +duration(10, 'seconds'),
    queryKey: [
      'blueprints', blueprintId, 'probe', probeId, 'stage', stageName, 'telemetry service warnings', queryParams
    ],
    refetchInterval: +duration(10, 'seconds'),
  }),
};

export const queryInvalidateKeys = {
  dashboard: (blueprintId: string | undefined, dashboardId: string | undefined) => [
    'blueprints', blueprintId, 'dashboard', dashboardId
  ],
  predefinedDashboardList: (blueprintId: string) => [
    'blueprints', blueprintId, 'predefined dashboards'
  ],
  probe: (blueprintId: string, probeId: string) => [
    'blueprints', blueprintId, 'probe', probeId
  ],
};
